/* eslint-disable no-undef, strict, no-console, no-unused-vars, eqeqeq */
/* global STORE */
RegExp.escape = (value) => {
	return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
};

function trim(str, chars) {
	return ltrim(rtrim(str, chars), chars);
}

function ltrim(str, chars) {
	str = str || '';
	chars = chars || '\\s';

	return str.replace(new RegExp('^[' + chars + ']+', 'g'), '');
}

function rtrim(str, chars) {
	str = str || '';
	chars = chars || '\\s';

	return str.replace(new RegExp('[' + chars + ']+$', 'g'), '');
}

function it(_variable_name, _vars) {
	var variable_name = _variable_name || '';
	var vars = _vars || {};
	var placeholders = {};
	var replacement = '';
	var result = _production ? '' : '{' + variable_name + '}';
	var placeholder_regex = /={2}([^=]+)={2}/mig;

	if (messages[variable_name]) {
		result = messages[variable_name];
		placeholders = result.match(placeholder_regex);

		for (let i in placeholders) {
			if (Object.prototype.hasOwnProperty.call(placeholders, i)) {
				placeholders[i] = placeholders[i] + '';
				placeholders[i] = placeholders[i].replace(/={2}/gim, '');
				replacement = vars[placeholders[i]] ? vars[placeholders[i]] : '';

				var _rep_regex = new RegExp('==' + RegExp.escape(placeholders[i] + '=='), 'mig');
				result = result.replace(_rep_regex, replacement);
			}
		}

		return result;
	}

	return result;
}

function url(page, args, absolute, ssl) {
	if (typeof page === 'undefined' || page === '')
		page = '/';

	var url = '';
	var arg_length = 0;
	args = args || '';
	ssl = ssl || _url_is_ssl;
	if (_url_root_url)
		_url_root_url = '/' + encodeURIComponent(trim(decodeURIComponent(_url_root_url), '/'));

	url = _url_root_url + '/' + trim(page, '/');

	if (absolute)
		url = (ssl ? 'https' : 'http') + '://' + _url_http_host + '/' + ltrim(url, '/');

	if (args) {
		var _args = '';
		$.each(args, function(attr, value) {
			_args += '&' + attr + '=' + encodeURIComponent(value);
			arg_length++;
		});

		if (arg_length)
			args = '?' + ltrim(_args, '&');
		else
			args = '';
	}

	return url + args;
}

function h(str) {
	str = new String(str);

	return str.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function fetcher(request, opts = {}) {
	//console.log('fetcher(%o, %o)', request, opts);
	if (opts.method.toLowerCase() === 'post') {
		if (!opts.body.has('_token')) {
			opts.body.append('_token', document.querySelector('form input[name=_token]')?.value);
		}

		const nothing_name = document.querySelector('form input[name^=_nothing_]')?.getAttribute('name');
		if (!opts.body.has(nothing_name)) {
			opts.body.append(nothing_name, '');
		}

		if (!opts.body.has('_snowman')) {
			opts.body.append('_snowman', '☃');
		}
	}

	const headers = {
		'X-Requested-With': 'XMLHttpRequest',
	};
	opts.headers = { ...headers, ...opts.headers };

	const controller = new AbortController();
	const signal = controller.signal;

	return {
		abort: () => controller.abort(),
		ready: (async () => {
			try {
				//console.log('fetch(%o, %o)', request, opts, signal);
				const result = await fetch(request, {...opts, signal});
				return await result.json();
			} catch (e) {
				if (e.name !== 'AbortError') {
					console.error('fetch error %o', e);
					throw new Error(e);
				}
			}
		})()
	};
}

function logEvent(event, data) {
	try {
		const form_data = new FormData();
		form_data.append('action', 'log_event');
		form_data.append('event', event);
		form_data.append('data', JSON.stringify(data));
		const fetch = fetcher(
			url('/account_process_checkout'),
			{
				method: 'post',
				body: form_data,
			}
		);
		return fetch.ready;
	} catch (e) {
		console.error(`Logging failed for ${event}: ${e.message}`);
	}
}